import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { TemplateTaskType } from '../../features/Settings/WorkflowSettings/autoRejectSetting/type';
import agent from '../api/agent';
import {
  AssetType,
  Template,
  TemplateSubTasks,
  elementTypes,
  TemplateTask,
  WorkflowElement,
  WorkflowOptions,
  CloneStructure,
} from './../models/template';

export default class TemplateStore {
  assetTypeRegistry = new Map<string, AssetType>();
  elementTypesRegistry = new Map<string, elementTypes>();
  templateRegistry = new Map<string, Template>();
  selectedAssetType: AssetType | undefined = undefined;
  selectedElementTypes: elementTypes | undefined = undefined;
  selectedTemplate: Template | undefined = undefined;
  selectedTasks: TemplateTask | TemplateTaskType | undefined = undefined;
  selectedSubTasks: TemplateSubTasks | undefined = undefined;
  selectedElement: WorkflowElement | undefined | any = undefined;
  loadingInitial = false;
  loadingInitialAT = false;
  loadingInitialET = false;
  loadingInitialTemp = false;
  loadingInitialTask = false;
  loadingInitialST = false;
  loadingInitialElem = false;
  loadingTemplate = false;
  viewpageCreateOrderload = false;
  parallelResponse: any[] = [];
  parallelSelectedResponse: {
    dependencyTask: string,
    isParallel:boolean
  }= {
    dependencyTask: '',
    isParallel: false
  };

  constructor() {
    makeAutoObservable(this);
  }

  ////////////////////////////////////////////////////////////////  Asset Types
  private setAssetType = (assetTypeDetails: AssetType) => {
    this.assetTypeRegistry.set(assetTypeDetails.id, assetTypeDetails);
  };

  get assetTypesByName() {
    return Array.from(this.assetTypeRegistry.values());
  }

  private getAssetType = (id: string) => {
    return this.assetTypeRegistry.get(id);
  };

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  loadAssetTypes = async () => {
    this.loadingInitialAT = true;
    this.loadingInitial = false;
    try {
      const assetTypeDetails = await agent.AssetTypes.listAssetTypes();
      assetTypeDetails.filter((x) => x.isDeleted === false);
      //sorting data
      assetTypeDetails.sort((a, b) => a.typeIndex - b.typeIndex);
      const assetTypeDetailsFiltered = assetTypeDetails?.filter(
        (item) => item.typeName !== 'Masters',
      );
      assetTypeDetailsFiltered.forEach((assetTypeDetails) => {
        runInAction(() => {
          this.setAssetType(assetTypeDetails);
        });
      });
      this.setLoadingInitial(false);
      this.loadingInitialAT = false;
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
        this.loadingInitialAT = false;
      });
    }
  };

  loadAssetTypesWithoutLoader = async () => {
    try {
      const assetTypeDetails = await agent.AssetTypes.listAssetTypes();
      assetTypeDetails.filter((x) => x.isDeleted === false);
      //sorting data
      assetTypeDetails.sort((a, b) => a.typeIndex - b.typeIndex);
      assetTypeDetails.forEach((assetTypeDetails) => {
        runInAction(() => {
          this.setAssetType(assetTypeDetails);
        });
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };

  loadAssetTypeById = async (id: string) => {
    this.loadingInitial = true;
    this.loadingInitialET = true;
    try {
      const AssetType = await agent.AssetTypes.assetTypeDetails(id);
      const fileteredData = AssetType?.elementTypes?.filter(
        (x) => x.isDeleted === false,
      ); //filtering data
      const sortedAssetType = {
        ...AssetType,
        elementTypes: fileteredData.sort(
          (a, b) => a.elementTypeIndex - b.elementTypeIndex,
        ),
      };
      this.setAssetType(AssetType);
      runInAction(() => {
        this.selectedAssetType = sortedAssetType;
      });
      this.setLoadingInitial(false);
      this.loadingInitialET = false;
      return sortedAssetType;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadingInitialET = false;
    }
  };

  //create Asset Type

  createNewAssetType = async (assetType: AssetType) => {
    try {
      await agent.AssetTypes.createAssetType(assetType);
      runInAction(() => {
        this.assetTypeRegistry.set(assetType.id, assetType);
      });
      toast.success('Asset Type Created Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
  //clone Asset Type
  cloneAssetType = async (parentId: string, childname: string) => {
    try {
      await agent.AssetTypes.cloneAssetType(parentId, childname);
      runInAction(() => {
        this.loadAssetTypes();
      });
      toast.success('Asset Type Cloned Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
  editAssetType = async (assetType: AssetType) => {
    this.loadingInitial = true;
    try {
      await agent.AssetTypes.editAssetType(assetType);
      runInAction(() => {
        this.selectedAssetType = assetType;
        this.assetTypeRegistry.set(assetType.id, assetType);
        // this.loadAssetTypes();
      });
      toast.success('Asset Type Edited Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
  deleteAssetType = async (assetType: AssetType) => {
    this.loadingInitial = true;
    try {
      await agent.AssetTypes.editAssetType(assetType);
      this.assetTypeRegistry.delete(assetType.id);
      runInAction(() => {
        this.loadAssetTypes();
      });
      toast.success('AssetType Deleted Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };

  ////////////////////////////////////////////////////////////////  TypeElement
  private setElementType = (elementTypeDetails: elementTypes) => {
    this.elementTypesRegistry.set(elementTypeDetails.id, elementTypeDetails);
  };
  loadElementTypes = async () => {
    this.loadingInitial = true;
    try {
      const elementTypeDetails = await agent.ElementTypes.listElementTypes();
      elementTypeDetails.filter((x) => x.isDeleted === false);
      //sorting data
      elementTypeDetails.sort(
        (a, b) => a.elementTypeIndex - b.elementTypeIndex,
      );
      elementTypeDetails.forEach((elementTypeDetails) => {
        runInAction(() => {
          this.setElementType(elementTypeDetails);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadElementTypeById = async (id: string) => {
    if (id !== null && id !== undefined && id !== '') {
      this.loadingInitial = true;
      this.loadingInitialTemp = true;
      try {
        const elementTypes = await agent.ElementTypes.elementTypesDetails(id);
        const fileteredData = elementTypes.templateTypes.filter(
          (x) => x.isDeleted === false,
        ); //filtering data
        const sortedElementType = {
          ...elementTypes,
          templateTypes: fileteredData.sort(
            (a, b) => a.templateIndex - b.templateIndex,
          ),
        };
        // this.setElementTypes(AssetType);
        runInAction(() => {
          this.selectedElementTypes = sortedElementType;
        });
        this.setLoadingInitial(false);
        this.loadingInitialTemp = false;
        return sortedElementType;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
        this.loadingInitialTemp = false;
      }
    } else {
      this.selectedElementTypes = undefined;
    }
  };
  //create Element Types

  //clone Element Types
  cloneElementTypes = async (data: CloneStructure) => {
    try {
      await agent.ElementTypes.cloneElementType(data);
      runInAction(() => {
        this.loadAssetTypeById(data.id);
      });
      toast.success('Element Type Cloned Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
  createElementUnderAssetType = async (
    assetType: AssetType,
    assetTypeFrontEnd: AssetType,
  ) => {
    this.loadingInitialET = true;
    try {
      await agent.ElementTypes.createElementTypesUnderAssetType(assetType);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedAssetType = assetTypeFrontEnd;
      });
      toast.success('Asset Updated Created Succesfully.');
      this.loadingInitialET = false;
    } catch (error) {
      console.log(error);
      this.loadingInitialET = false;
    }
  };
  editElementType = async (elementType: elementTypes) => {
    this.loadingInitial = true;
    try {
      await agent.ElementTypes.editElementType(elementType);

      runInAction(() => {
        this.selectedElementTypes = elementType;
        this.elementTypesRegistry.set(elementType.id, elementType);
      });
      toast.success('Element Type Edited Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
  deleteElementType = async (
    elementTypes: elementTypes,
    assetTypeFE: AssetType,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.ElementTypes.editElementType(elementTypes);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedAssetType = assetTypeFE;
      });
      toast.success('Element Type Deleted Succesfully');
    } catch (error) {
      console.log(error);
    }
  };

  /////////////////////////////////////////////////////////////////// Templates

  get templatesByName() {
    return Array.from(this.templateRegistry.values());
  }

  private setTemplate = (templatesDetails: Template) => {
    this.templateRegistry.set(templatesDetails.templateId, templatesDetails);
  };

  loadTemplates = async () => {
    this.loadingInitial = true;
    // this.loadingTemplate=true;
    try {
      const templatesDetails = await agent.Templates.list();
      templatesDetails.filter((element) => element.isDeleted === false);

      templatesDetails.forEach((templatesDetails) => {
        runInAction(() => {
          this.setTemplate(templatesDetails);
        });
      });
      this.setLoadingInitial(false);
      this.loadingTemplate = false;
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadTemplateById = async (id: string) => {
    this.loadingInitial = true;
    this.loadingInitialTask = true;
    try {
      const template = await agent.Templates.templateDetails(id);
      const filteredTask: TemplateTask[] = template.tasks.filter(
        (x) => x.isDeleted === false,
      );
      const filtersub = filteredTask.map((task) => ({
        ...task,
        subTasks: task?.subTasks
          ?.filter((x) => x.isDeleted === false)
          .map((subtask) => ({
            ...subtask,
            elements: subtask?.elements.filter((y) => y.isDeleted === false),
          })),
      }));

      const sortedTemplate = {
        ...template,
        tasks: filtersub.sort((a, b) => a.taskIndex - b.taskIndex),
      };

      this.setTemplate(sortedTemplate);
      runInAction(() => {
        this.selectedTemplate = sortedTemplate;
        
      });
      this.setLoadingInitial(false);
      this.loadingInitialTask = false;
      return sortedTemplate;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadingInitialTask = false;
    }
  };

  loadParallelTasks = async (templateId: string, currentTaskIndex: number) => {
    try {
      const response = await agent.TemplateTasks.parallelTask({
        TemplateId: templateId,
        currentTaskIndex: currentTaskIndex,
      });
      runInAction(() => {
        this.parallelResponse = response.data;
      });
    } catch (error) {
      toast.error('Unable to fetch dependency. Pls Try Again !');
      console.error(error);
      throw error;
    }
  };

  loadParallelTaskSelected = async (taskId:string) => {
    try {
      const response = await agent.TemplateTasks.parallelTaskSelected({taskId: taskId});
      runInAction(() => {
        this.parallelSelectedResponse = response.data;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  loadParallelTaskUpdate = async(taskId: string, payload:{
    dependencyTask: string | any[] | undefined,
    isParallel: boolean | undefined,
  }) => {
    try {
      await agent.TemplateTasks.parallelTaskUpdate(taskId, payload);
      runInAction(() => {
        toast.success('Dependency Task updated');
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  loadTemplateIdForCR = async (id: string) => {
    this.loadingInitial = true;
    this.loadingInitialTask = true;
    if (id === '') {
      this.selectedTemplate = undefined;
    } else {
      try {
        const template = await agent.Templates.templateDetailsAll(id);
        let filteredData = template.tasks.filter(
          (x) => x.isDeleted === false && x.isActive === true,
        ); //filtering data
        const filtersub = filteredData.map((task) => ({
          ...task,
          subTasks: task?.subTasks
            ?.filter((x) => x.isDeleted === false && x.isActive === true)
            .sort((a, b) => a.subtaskIndex - b.subtaskIndex)
            .map((subtask) => ({
              ...subtask,
              elements: subtask?.elements.filter(
                (y) => y.isDeleted === false && y.isActive === true,
              ),
            })),
        }));
        const sortedTemplate = {
          ...template,
          tasks: filtersub.sort((a, b) => a.taskIndex - b.taskIndex),
        };
        this.setTemplate(sortedTemplate);
        runInAction(() => {
          this.selectedTemplate = sortedTemplate;
        });
        this.setLoadingInitial(false);
        this.loadingInitialTask = false;
        return sortedTemplate;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
        this.loadingInitialTask = false;
        this.selectedTemplate = undefined;
      }
    }
  };

  //clone template
  cloneTemplate = async (data: CloneStructure) => {
    try {
      await agent.Templates.cloneTemplate(data);
      runInAction(() => {
        this.loadElementTypeById(data.id);
      });
      toast.success('Template Cloned Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };

  UpdateTemplate = async (template: Template) => {
    try {
      await agent.Templates.updateTemplate(template);
      runInAction(() => {
        this.templateRegistry.set(template.templateId, template);
      });
      toast.success('Template Edited Successfully');
    } catch (error) {
      console.log(error);
    }
  };

  createTemplateUnderElementType = async (
    elementType: elementTypes,
    elemetTypeFrontEnd: elementTypes,
  ) => {
    this.loadingInitialElem = true;
    try {
      await agent.Templates.createTemplateUnderElementType(elementType);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedElementTypes = elemetTypeFrontEnd;
      });
      toast.success('Template Updated Created Succesfully.');
      this.loadingInitialElem = false;
    } catch (error) {
      console.log(error);
      this.loadingInitialElem = false;
    }
  };
  deleteTemplateType = async (
    template: Template,
    elementTypeFE: elementTypes,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.Templates.updateTemplate(template);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedElementTypes = elementTypeFE;
      });
      toast.success('Template Deleted Succesfully');
    } catch (error) {
      console.log(error);
    }
  };

  /////////////////////////////////////////////////////////////////// Tasks
  loadTaskById = async (id: string) => {
    try {
      this.loadingInitial = true;
      this.loadingInitialST = true;
      const templateTasks = await agent.TemplateTasks.taskDetails(id);
      const fileteredData = templateTasks.subTasks.filter(
        (x) => x.isDeleted === false,
      ); //filtering data
      const sortedTasks = {
        ...templateTasks,
        subTasks: fileteredData.sort((a, b) => a.subtaskIndex - b.subtaskIndex),
      };
      runInAction(() => {
        this.selectedTasks = sortedTasks;
      });
      this.setLoadingInitial(false);
      this.loadingInitialST = false;
      return sortedTasks;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadingInitialST = false;
    }
  };

  updateSubTaskTat = async (subTaskId: string, updatedTat: string) => {
    try {
      await agent.TemplateTasks.updateTatForSubTask(subTaskId, updatedTat);
      runInAction(() => {
        toast.success('SubTask Time updated');
      });
    } catch {
      toast.error('Something went wrong ! Please update TAT again.');
    }
  };

  cloneTasks = async (data: CloneStructure) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateTasks.cloneTasks(data);
      runInAction(() => {
        this.loadTemplateById(data.id);
      });
      toast.success('Task Cloned Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
  editTasks = async (tasks: TemplateTask) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateTasks.editTask(tasks);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedTasks = tasks;
      });
      toast.success('Task Edited Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      toast.error('Task Edited failed.');
      console.log(error);
    }
  };
  createTasksUnderTemplate = async (
    templateTask: Template,
    templateTaskFrontEnd: Template,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateTasks.createTaskUnderTemplate(templateTask);
      this.loadTemplates();

      runInAction(() => {
        this.selectedTemplate = templateTaskFrontEnd;
      });
      toast.success('Template Updated Created Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
    }
  };
  deleteTaskType = async (task: TemplateTask, taskFE: Template) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateTasks.deleteTask(task.taskId);
      await agent.TemplateTasks.arrangeIndex(
        (this.selectedTemplate?.templateId as string) || '',
      );
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedTemplate = taskFE;
      });
      toast.success('Task Deleted Succesfully');
    } catch (error) {
      console.log(error);
    }
  };
  /////////////////////////////////////////////////////////////////// Sub Tasks
  loadSubTaskById = async (id: string) => {
    try {
      this.loadingInitial = true;
      this.loadingInitialElem = true;
      const templateSubTasks = await agent.TemplateSubtasks.subTaskDetails(id);
      const fileteredData = templateSubTasks.elements.filter(
        (x) => x.isDeleted === false,
      ); //filtering data
      const sortedSubTasks = {
        ...templateSubTasks,
        elements: fileteredData.sort((a, b) => a.elementIndex - b.elementIndex),
      };
      runInAction(() => {
        this.selectedSubTasks = sortedSubTasks;
      });
      this.setLoadingInitial(false);
      this.loadingInitialElem = false;
      return sortedSubTasks;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
      this.loadingInitialElem = false;
    }
  };

  createSubtaskUnderTask = async (
    task: TemplateTask,
    taskFrontEnd: TemplateTask,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateSubtasks.createSubtaskUnderTask(task);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedTasks = taskFrontEnd;
      });
      toast.success('Subtask Updated  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
    }
  };
  editSubTasks = async (subtasks: TemplateSubTasks) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateSubtasks.editSubTask(subtasks);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedSubTasks = subtasks;
      });
      toast.success('SubTask Edited  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      toast.error('SubTask Edited failed.');
      console.log(error);
    }
  };
  cloneSubTasks = async (data: CloneStructure) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateSubtasks.cloneSubTasks(data);
      runInAction(() => {
        this.loadTaskById(data.id);
      });
      toast.success('SubTask Cloned Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };
  deleteSubTask = async (subtask: TemplateSubTasks, Task: TemplateTask) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateSubtasks.deleteSubtask(subtask.subTaskId);
      await agent.TemplateSubtasks.arrangeIndex(
        (this.selectedTasks?.taskId as string) || '',
      );
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedTasks = Task;
      });
      toast.success('Sub Task Deleted Succesfully');
    } catch (error) {
      console.log(error);
    }
  };
  /////////////////////////////////////////////////////////////////////////////////////////elements
  loadElementById = async (id: string) => {
    try {
      const workflowelement = await agent.TemplateElements.elementDetails(id);
      runInAction(() => {
        this.selectedElement = workflowelement;
      });
      this.setLoadingInitial(false);
      return workflowelement;
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };
  cloneElements = async (data: CloneStructure) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateElements.cloneElements(data);
      runInAction(() => {
        this.loadSubTaskById(data.id);
      });
      toast.success('Elements Cloned Succesfully.');
    } catch (error) {
      console.log(error);
    }
  };

  createElementUnderSubtask = async (
    subTask: TemplateSubTasks,
    subtaskFrontEnd: TemplateSubTasks,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateElements.createElementUnderSubTask(subTask);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedSubTasks = subtaskFrontEnd;
      });
      toast.success('Element Updated  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
    }
  };
  editElements = async (elements: WorkflowElement) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateElements.editElement(elements);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedElement = elements;
      });
      toast.success('Element Edited  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      toast.error('Element Edited failed.');
      console.log(error);
    }
  };
  elementToggleOffEdit = async (elementId: string) => {
    try {
      await agent.TemplateElements.elementToggleOffEditAPI(elementId);
      toast.success('Element Edited Succesfully.');
    } catch (error) {
      toast.error('Element Edited failed.');
      console.log(error);
    }
  };
  subTaskelementToggleOffEdit = async (subTaskId: string) => {
    try {
      await agent.TemplateSubtasks.subTaskToggleOffEditAPI(subTaskId);
      toast.success('Element Edited Succesfully.');
    } catch (error) {
      toast.error('Element Edited failed.');
      console.log(error);
    }
  };

  editSettingsElements = async (elements: WorkflowElement) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateElements.editElement(elements);
      this.loadAssetTypesWithoutLoader();
      runInAction(() => {
        this.selectedElement = elements;
        // this.selectedSubTasks=subTaskArr;
      });
      toast.success('Element Edited  Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      toast.error('Element Edited failed.');
      console.log(error);
    }
  };

  deleteElements = async (
    element: WorkflowElement,
    SubTask: TemplateSubTasks,
  ) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateElements.deleteElement(element.elementId);
      this.loadAssetTypes();
      runInAction(() => {
        this.selectedSubTasks = SubTask;
      });
      toast.success('Element Deleted Succesfully');
    } catch (error) {
      console.log(error);
    }
  };
  /////////////////////options
  editOptions = async (options: WorkflowOptions) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateOptions.editOptions(options);
      toast.success('Option Edited Succesfully.');
      this.setLoadingInitial(false);
    } catch (error) {
      toast.error('Option Edited failed.');
      console.log(error);
    }
  };
  deleteOptions = async (id: string, componentName: string) => {
    this.loadingInitial = true;
    try {
      await agent.TemplateOptions.deleteOptionsAPI(id);
      if (componentName === 'DropDown')
        toast.success('Option Deleted Successfully.');
      else {
        toast.success('Column header deleted successfully.');
      }
      this.setLoadingInitial(false);
    } catch (error) {
      if (componentName === 'DropDown') toast.error('Option Delete failed.');
      else {
        toast.success('Column header delete failed.');
      }
      console.log(error);
    }
  };
}
